import React from 'react';
import { Stack, Typography } from '@mui/material';
import { ModalType } from 'entities/modal/model';
import { COLOR_GRAY_4, Modal, Spinner } from 'shared';

export interface ApproveModalPayload {
  data?: null;
  type: ModalType.Approve;
  isOpen?: boolean;
}

export const ApproveModal = React.forwardRef<
  HTMLElement,
  Pick<ApproveModalPayload, 'data' | 'isOpen'> & { onClose: VoidFunction }
>(({ onClose }, ref) => {
  return (
    <Modal ref={ref}>
      <Stack alignItems="center">
        <Typography variant="h5" component="span" color="inherit" className="no-resize">
          STEP 1/2{' '}
          <Typography variant="inherit" component="span" className="accent">
            APPROVE
          </Typography>
        </Typography>
        <Spinner
          sx={{
            mt: 4,
            mb: 3,
          }}
        />
        <Typography
          variant="h5"
          className="center"
          component="span"
          color="inherit"
          fontSize={18}
          sx={{
            maxWidth: 340,
          }}
        >
          Please press &quot;Approve&quot; button in Metamask extension
        </Typography>
      </Stack>
    </Modal>
  );
});
